import TestApiController from './test.api.controller';

export default {
    template: require('./list.html'),
    controller: TestApiController
};
